export const DEFAULT_PROGRESS = 80;
